import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { KeyboardArrowUp } from "@mui/icons-material";
import { tokens } from "../../../theme";

interface UpcomingAuditsMinimisedPillProps {
  overdueCount: number;
  inDangerCount: number;
  onExpand: () => void;
}

const UpcomingAuditsMinimisedPill = ({
  overdueCount,
  inDangerCount,
  onExpand,
}: UpcomingAuditsMinimisedPillProps) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box onClick={onExpand} sx={{ cursor: "pointer" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          borderRadius: 50,
          backgroundColor: colors.primary[800],
          border: `1px solid ${colors.primary[300]}30`,
          "&:hover": { backgroundColor: colors.primary[800] },
          overflow: "hidden",
        }}
      >
        {/* Label */}
        <Box sx={{ px: 2.5, py: 1.5 }}>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "0.75rem",
              letterSpacing: "0.08em",
              color: colors.primary[700],
              textTransform: "uppercase",
              whiteSpace: "nowrap",
            }}
          >
            Upcoming Audits
          </Typography>
        </Box>

        {/* Divider */}
        <Box
          sx={{
            width: "1px",
            height: 40,
            backgroundColor: colors.primary[300] + "40",
          }}
        />

        {/* Overdue */}
        <Box
          sx={{
            px: 2,
            py: 1.5,
            display: "flex",
            alignItems: "center",
            gap: 0.8,
          }}
        >
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: "#E11D48",
            }}
          />
          <Typography
            sx={{ fontWeight: 700, fontSize: "0.85rem", color: "#E11D48" }}
          >
            {overdueCount}
          </Typography>
          <Typography sx={{ fontSize: "0.7rem", color: colors.primary[700] }}>
            overdue
          </Typography>
        </Box>

        {/* Divider */}
        <Box
          sx={{
            width: "1px",
            height: 40,
            backgroundColor: colors.primary[300] + "40",
          }}
        />

        {/* In Danger */}
        <Box
          sx={{
            px: 2,
            py: 1.5,
            display: "flex",
            alignItems: "center",
            gap: 0.8,
          }}
        >
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: "#f59e0b",
            }}
          />
          <Typography
            sx={{ fontWeight: 700, fontSize: "0.85rem", color: "#f59e0b" }}
          >
            {inDangerCount}
          </Typography>
          <Typography sx={{ fontSize: "0.7rem", color: colors.primary[700] }}>
            in danger
          </Typography>
        </Box>

        {/* Expand icon */}
        <Box sx={{ px: 1.5, display: "flex", alignItems: "center" }}>
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onExpand();
            }}
            sx={{
              color: colors.primary[100],
              p: 0.5,
              ml: -0.5,
              flexShrink: 0,
              "&:hover": { color: "white", backgroundColor: "transparent" },
            }}
          >
            <KeyboardArrowUp sx={{ fontSize: 18 }} />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default UpcomingAuditsMinimisedPill;
